export const iconFontAwesomeFoodBeverageBurger = (
	<i className="fa-solid fa-burger"></i>
);
